<template>
  <v-container style="margin-top: 20px;">
    <v-row  >
      <v-col lg="4" sm="6" md="4" cols="12" v-for="(shop,index) in products" :key="index"
             v-on:click="router.push({ path: 'purchase', query: {id:shop.id, url: shop.url, description:shop.description, price:shop.price, name:shop.title } })">
        <shop-card
                   v-bind:style="windowWidth>600?'width: 100%;height:80%;':'width: 100%;height:300px;'"
                   :id="shop.id"
                   :name="shop.title" :url="shop.url" :details="shop.description" :price="shop.price">
        </shop-card>
      </v-col>
    </v-row>


  </v-container>
</template>

<script>
import ShopCard from "@/components/shopCard";
import router from "@/router";
import {fetchProducts} from "@/shared/productsService";
import constants from "@/api/constants";

export default {
  name: "shop",
  components: {ShopCard},
  data() {
    return {
      windowWidth: window.innerWidth,
      router,
      products: []
    }
  },
  async created() {
    var response = (await fetchProducts());
    console.log(response.data);
    this.products = response.data.map(pro => {
      console.log(pro.media[0].id);
      return {
        ...pro,
        url: `${constants.host}api/media/${pro.media[0].id}`
      };
    });
  }
  , methods: {
    reDirect() {
      let routeData = this.$router.resolve('https://medium.com/js-dojo/form-validation-with-vuetify-in-a-vue-app-d72e3d9b65db');
      window.open(routeData.href, '_blank');
    },
  }
}
</script>

<style scoped>
.container {
  max-width: 1300px;
  height: auto !important;
}


</style>
